import { ChangeDetectionStrategy, Component, EventEmitter, Input, model, Output, signal, input, computed } from '@angular/core';
import { UBaseInfraComponent } from '../u-base-infra.component';
import type { AbstractControl, FormControl } from '@angular/forms';
import type { MatSlideToggleChange } from '@angular/material/slide-toggle';

@Component({
  selector: 'u-toggle-switch',
  templateUrl: './u-toggle-switch.component.html',
  styleUrls: ['./u-toggle-switch.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UToggleSwitchComponent extends UBaseInfraComponent {
  checked = input<boolean>(false);
  formControl = input<AbstractControl>(null, { alias: 'fieldFormControl' });
  fieldFormControl = computed<FormControl | null>(() => this.formControl() as FormControl);

  @Output() onChange = new EventEmitter<MatSlideToggleChange>();

  getIconRef() {
    return null;
  }
}
